import React from "react";
import Modal from "@material-ui/core/Modal";

import "./FarmMapSyncLeaveModal.css";

function FarmMapSyncLeaveModal({
  open,
  t,
  loading = false,
  onStay,
  onLeaveWithoutSync,
  onSyncAndLeave,
  title,
  body,
  question,
}) {
  return (
    <Modal open={open} onClose={onStay} aria-labelledby="farm-map-sync-leave-title">
      <div
        className="farm-map-sync-leave-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="farm-map-sync-leave-title">
          {title || t("Sincronizar com o app de campo?")}
        </h2>
        <p>
          {body ||
            t(
              "Há alterações no mapa que ainda não foram enviadas ao app de campo. " +
                "Sem sincronizar, os tablets não receberão talhões, linhas e rumos A-B atualizados."
            )}
        </p>
        <p className="farm-map-sync-leave-modal__question">
          {question || t("Deseja sair desta página sem sincronizar?")}
        </p>
        <div className="farm-map-sync-leave-modal__actions">
          <button
            type="button"
            className="btn btn-default"
            onClick={onStay}
            disabled={loading}
          >
            {t("Não, continuar editando")}
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={onLeaveWithoutSync}
            disabled={loading}
          >
            {t("Sim, sair sem sincronizar")}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onSyncAndLeave}
            disabled={loading}
          >
            {loading ? t("Sincronizando...") : t("Sincronizar e sair")}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default FarmMapSyncLeaveModal;
